var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useReport } from '@tencent/dz-report';
import { TransformType } from '../../const';
export var useReportService = function (_a) {
    var moduleParams = _a.moduleParams, palyload = _a.palyload;
    var report = useReport();
    var getElementParams = function () {
        switch (palyload.buttonType) {
            case TransformType.phone:
                return {
                    element_type: 'phone_button',
                    element_chinese_type: '电话按钮',
                    element_content: '电话快速咨询',
                };
            case TransformType.form:
                return {
                    element_type: 'form_button',
                    element_chinese_type: '表单按钮',
                    element_content: '免费获取诊疗方案',
                };
            case TransformType.consult:
                return {
                    element_type: 'consult_button',
                    element_chinese_type: '咨询按钮',
                    element_content: "\u54A8\u8BE2\u201C" + palyload.query + "\u201D",
                };
            default:
                return {};
        }
    };
    var params = __assign(__assign(__assign({}, moduleParams), { element_id: 4 }), getElementParams());
    React.useEffect(function () {
        report.exposure(params);
    }, []);
    var transformClick = function () {
        report.click(params);
    };
    return {
        transformClick: transformClick,
    };
};
